import { CelebrationEvent } from '../interfaces/celebration-event.interface';

export const Celebration: CelebrationEvent[] = [
  {
    type: 'christmas',
    startMonth: 12, // Christmas celebration
    startDay: 20,
    endMonth: 12,
    endDay: 26,
    priority: 0, // Highest priority - Christmas overrides winter
  },
  {
    type: 'winter',
    startMonth: 12, // Winter starts in December
    startDay: 1,
    endMonth: 2, // Winter ends in February
    endDay: 28, // Through end of February (29 in leap years)
    priority: 1
  },
  {
    type: 'halloween',
    startMonth: 10,
    startDay: 20,
    endMonth: 10,
    endDay: 31,
    priority: 0 // High priority - October celebrations
  },
  {
    type: 'default',
    startMonth: 1,
    startDay: 1,
    endMonth: 12,
    endDay: 31,
    priority: 999 // Lowest priority - always active as fallback
  }
];
